import { render, staticRenderFns } from "./VideoAngleList.vue?vue&type=template&id=6096e548&scoped=true&"
import script from "./VideoAngleList.vue?vue&type=script&lang=js&"
export * from "./VideoAngleList.vue?vue&type=script&lang=js&"
import style0 from "./VideoAngleList.vue?vue&type=style&index=0&id=6096e548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096e548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
